var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    rx: 40.5,
    transform: "matrix(-1 0 0 1 81 0)",
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121_3362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5065 33.1195C32.7627 33.332 32.8377 33.5758 32.7502 33.882C32.7065 34.032 31.8877 34.8945 29.644 37.1508L26.594 40.2195L41.0627 40.2508C52.219 40.2758 55.5627 40.3008 55.6627 40.357C55.9815 40.5383 56.1127 41.1258 55.9002 41.4258C55.6565 41.7758 56.6815 41.7508 40.9877 41.7508H26.5315L29.6315 44.857C31.6065 46.8383 32.7502 48.0258 32.7752 48.132C32.8252 48.357 32.7127 48.707 32.5377 48.8695C32.344 49.057 31.9502 49.107 31.7127 48.982C31.6127 48.9258 29.8377 47.1883 27.7627 45.1133L24.0002 41.3445V41.0008V40.657L27.8377 36.8195L31.6752 32.982L31.9752 32.957C32.244 32.932 32.3065 32.9508 32.5065 33.1195Z",
    fill: "#182948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_3362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 56 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.5931316b643321f90a64c0278da19e5f.svg";
export { ForwardRef as ReactComponent };